import api from '@/axios'

export default {
  findAll () {
    return api().get('user-transaction')
  },
  findOne (id) {
    return api().get(`user-transaction/${id}`)
  }
}
